import React, { useState } from 'react';
import Button from './Button';
import Modal from './Modal';
import './RatingModal.css';

const RatingModal = ({ isOpen, onClose, contractId, vesselName, vendorName, onSuccess }) => {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [review, setReview] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const getToken = () => localStorage.getItem('marilink_token');

  const handleSubmit = async () => {
    if (rating === 0) {
      setError('Please select a rating');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const token = getToken();
      const response = await fetch(`${API_BASE}/ratings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ contractId, rating, review })
      });
      const data = await response.json();
      if (data.success) {
        if (onSuccess) onSuccess();
        onClose();
      } else {
        setError(data.message || 'Failed to submit rating');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i
          key={i}
          className={`fas fa-star ${i <= (hoverRating || rating) ? 'active' : ''}`}
          onClick={() => setRating(i)}
          onMouseEnter={() => setHoverRating(i)}
          onMouseLeave={() => setHoverRating(0)}
        />
      );
    }
    return stars;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Rate Service Provider">
      <div className="rating-modal">
        <div className="rating-vendor-info">
          <p><strong>{vendorName}</strong> for <strong>{vesselName}</strong></p>
        </div>
        <div className="rating-stars">
          {renderStars()}
        </div>
        <div className="rating-review">
          <label>Review (optional)</label>
          <textarea
            rows="3"
            value={review}
            onChange={(e) => setReview(e.target.value)}
            placeholder="Share your experience with this provider..."
          />
        </div>
        {error && <div className="rating-error">{error}</div>}
        <div className="rating-actions">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button variant="primary" onClick={handleSubmit} disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit Rating'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RatingModal;